import { render, staticRenderFns } from "./MedicalAction.vue?vue&type=template&id=d824aaa2&"
import script from "./MedicalAction.vue?vue&type=script&lang=js&"
export * from "./MedicalAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports